<div>
  <form id="hoursEntry" #hoursEntry="ngForm">
    <h5>
      {{title}}
    </h5>

    @if (!task.isGoBack) {
      <textarea name="feedback" [rows]="5" style="width: 100%" pInputTextarea [(ngModel)]="task.jobFeedback" required></textarea>
    }
    @if (task.isGoBack) {
      <textarea name="feedback" [rows]="5" style="width: 100%" pInputTextarea [(ngModel)]="task.goBackFeedback" required></textarea>
    }

    <h5>
      HOURS ON THE JOB
    </h5>
    <div>
      Please submit to the quarter hour. Example: if employee worked 6 hrs & 15 minutes, input 6.25.
    </div>

    <div class="calendar-space">
      <p-datepicker id="workDate" appendTo="body" name="workDate" [(ngModel)]="workDate" [showIcon]="true" (ngModelChange)="filter(workDate)"></p-datepicker>
    </div>

  <div style="text-align: center;">
    <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
  </div>
    @if (scheduledBucket || bigDayBucketSubrange) {
      <div style="max-height: 15em; overflow-x: hidden;">
        @for (taskHourEntry of dateFilteredEmployees; track taskHourEntry) {
          <div>
            @if (asGoBack ? taskHourEntry.isGoBack : !taskHourEntry.isGoBack) {
              <div class="p-grid">
                <div class="p-col-6" style="align-self: center">
                  <app-employee-card [employee]="taskHourEntry.employee" [deleteable]="false"></app-employee-card>
                </div>
                <div class="p-col-6">
                  <input fluid required type="text" pInputText [(ngModel)]="taskHourEntry.hours" (ngModelChange)="getHourTotal()" [name]="taskHourEntry.id + '-' + taskHourEntry.employeeId + '-hours'" />
                </div>
              </div>
            }
          </div>
        }
        @if (addingEmployee) {
          <div>
            <ng-select class="custom" required [items]="employees" placeholder="Select an Employee" [selectOnTab]="true"
              (ngModelChange)="addNewTaskHourEntry($event)" name="certifiedApplicator" bindLabel="fullName"
              [(ngModel)]="selectedEmployee">
            </ng-select>
          </div>
        }
      </div>
    }

    <div class="p-grid">
      <div class="p-col-6 ui-fluid">
        <p-button type="button" label="Add Employee" icon="pi pi-plus" severity="secondary" (click)="addEmployee()"></p-button>
      </div>
      <div class="p-col-6" style="text-align: right;">
        Day Total: {{dayHours}} hrs
        <br/>
        Overall Total: {{totalHours}} hrs
      </div>
      <div class="p-col-12" style="text-align: right;">
      </div>
    </div>
    @if (unableToComplete) {
      <div style="margin-bottom: 5px;">
        <p-checkbox name="unableToCompletePermanently" [(ngModel)]="unableToCompletePermanently" binary="true"></p-checkbox>
        <label for="unableToCompletePermanently">Permanently Unable to Complete?</label>
        <!-- Focus doesn't seem to work even with hacks, so I'm just using it to turn this off then using p-overlay for mobile.  -->
        <i #TheMostIrritatingIconInTheWorld
          style="vertical-align: middle; margin: auto;"
          class="pi pi-info-circle"
          (click)="onInfoClick($event)"
          [pTooltip]="iconMessage"
          >
          @if (isTouchscreen) {
            <p-popover #op [appendTo]="'body'">
              {{iconMessage}}
            </p-popover>
          }
        </i>
      </div>
    }

    @if (verifyPrice) {
      <div>
        <h5>
          CONFIRM PRICE
        </h5>
        <div>
          Please input the final price of this task (not including tax). If needed, please consult with the Regional Manager on the work order to ensure you are submitting the correct price. The price you input below is what the customer will receive in their invoice.
        </div>
        <div class="fine-print">
          {{priceInfo}}
        </div>
        <div>
          <app-no-decimal-input 
              [name]="'price'" 
              [isRequired]="true" 
              [isDisabled]="false" 
              [value]="task.price"
              [minimumValue]="task.minPrice"
              (emitResult)="task.price=$event"
            ></app-no-decimal-input>
          </div>
          <br/>
        </div>
      }

      <p-button type="submit" label="Submit" (click)="submit(hoursEntry)" severity="success"[disabled]="disableSubmit || (!scheduledBucket && !bigDayBucketSubrange)"></p-button>
    </form>
  </div>